const SUFFIXES = { 1: 'st', 2: 'nd', 3: 'rd' };

export default function ordinalize(num: number) {
  const modulo100 = num % 100;
  if (modulo100 >= 10 && modulo100 <= 20) {
    return 'th';
  }
  const modulo10 = num % 10;
  if (modulo10 in SUFFIXES) {
    return SUFFIXES[modulo10];
  }
  return 'th';
}
